import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { IconRegularChevronLeft } from '@notino/react-styleguide';

import { Hidden } from '@components/Hidden';
import { WISHLIST_BASE_URL } from '@constants';
import { useListById } from '@containers/WishList/hooks/useListById';
import messages from '@containers/WishList/messages';
import { ListMenuDrawer } from '@containers/WishlistLists/components/ListMenuDrawer';
import { useWishlistSpaNavigate } from '@containers/wishlistShared/useWishlistSpaNavigate';

import { BackLink, HeaderOptions, HeaderTitle, HeaderWrapper } from './styled';

type Props = {
  isShared: boolean;
};

export const WishlistHeader = ({ isShared }: Props) => {
  const { listById } = useListById();
  const [listMenuOpen, setListMenuOpen] = React.useState(false);
  const wishlistNavigate = useWishlistSpaNavigate();

  return (
    <>
      <HeaderWrapper>
        <Hidden breakpoint="md">
          <BackLink
            href={WISHLIST_BASE_URL}
            onClick={(e) => wishlistNavigate(WISHLIST_BASE_URL, e)}
          >
            <IconRegularChevronLeft height="1.25rem" width="1.25rem" />
          </BackLink>
        </Hidden>

        <HeaderTitle>
          {isShared ? (
            <FormattedMessage {...messages.sharedProducts} />
          ) : (
            listById.name
          )}
        </HeaderTitle>

        {isShared ? (
          <div style={{ width: 44 }} /> // to keep title centered
        ) : (
          <HeaderOptions onClick={() => setListMenuOpen(true)} />
        )}
      </HeaderWrapper>

      {listMenuOpen && (
        <ListMenuDrawer
          onClose={() => setListMenuOpen(false)}
          list={
            {
              ...listById,
              id: listById.id ?? '',
              isShared,
            } as any
          }
        />
      )}
    </>
  );
};
